module.exports = __webpack_public_path__ + "19239f80c83b5404943d150e98fe2ccf.svg";